// Module
var code = "\n<!-- ko foreach: options -->\n<fc-check params=\"type: 'radio', checked: $parent.value() === $data.id,\n  label: $data.label,\n  name: $parent._id,\n  onChange: function() {\n    $parent.value($data.id)\n  },\n  disabled: $parent.disabled\" data-bind=\"css: {\n    'checked': $parent.value() === $data.id\n  }\"></fc-check>\n<!-- /ko -->\n";
// Exports
module.exports = code;